import { FC, MouseEvent } from 'react';
import { Box, Stack, Theme } from '@mui/material';
import { createUseStyles } from 'react-jss';
import Icon from '../icon';
import Text from '../text';
import McpServerIcon from '../mcp-server-icon';
import { McpToolModel } from '@/lib/models/mcp-tool/mcp-tool.model';
import { McpServerModel } from '@/lib/models/mcp-server.model';

interface Props {
  mcpTool: McpToolModel;
  mcpServer?: McpServerModel;
  onInfoClick?: (event: MouseEvent, mcpTool: McpToolModel) => void;
}

const useStyles = createUseStyles((theme: Theme) => ({
  mcpToolButton: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  description: {
    maxHeight: 100,
    overflowY: 'auto',
  },
}));

const McpToolButton: FC<Props> = ({ mcpTool, mcpServer = new McpServerModel(), onInfoClick }) => {
  const styles = useStyles();
  const { serverName, name } = mcpTool;
  const { icon, title: niceServerName } = mcpServer;

  const hasInfoButton = !!onInfoClick;
  const displayServerName = niceServerName || serverName;

  return (
    <Box className={styles.mcpToolButton} p={1} width="100%">
      <Stack direction="row" gap={1} alignItems="flex-start" width="100%">
        <McpServerIcon icon={icon} serverName={displayServerName} />
        <Stack>
          <Text size="small">{displayServerName}</Text>
          <Stack direction="row">
            <Icon name="sub-arrow-right" size="x-small" />
            <Text size="small">{name}</Text>
          </Stack>
        </Stack>
        {hasInfoButton && (
          <Stack flexDirection="row" justifyContent="flex-end" alignItems="center" flexGrow={1}>
            <Icon
              name="info-circle"
              onClick={(event: MouseEvent) => onInfoClick(event, mcpTool)}
              size="small"
              color="grey"
            />
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default McpToolButton;
